module.exports = __webpack_public_path__ + "img/fashion_39.6f708e95.jpg";